// WHAT THE USER HAS DECIDED ABOUT A THREAD'S FOUND DOCUMENTS (busy-my-web#416, frame 5004:85450).
//
// The reply Work-board lists the documents the AI found for the mail being answered, each with a
// Confirm and a Delete. Both answers have to outlive the row: a confirmed file must go on being
// reported ("Confirmed 2 found files" on the thread's rail, "confirmed files" under Focus) and a
// deleted one must not come back the next time the draft re-renders.
//
// There is NO endpoint for either answer — no service records a per-thread document confirmation
// today — so both are held here, keyed by thread, for the life of the session. This module is
// deliberately the whole of that: state, and the two verbs that write it. The moment the BFF grows
// a route (`POST timeline/{id}/found-documents/{ref}/confirm` would be the shape) it is dispatched
// from these same two actions and every reader keeps working.

export const state = {
  // { [timelineId]: [{ id, ref, at, files: [name] }] } — one entry per Confirm.
  confirmed: {},
  // { [timelineId]: [ref] } — the rows the user said were not the file.
  dismissed: {},
}

export const getters = {
  // Getters that TAKE an id rather than reading a "current thread": the rail, the Focus column and
  // the board can each be about a different thread at the same moment (the reader is mounted in two
  // places), and none of them should have to set a global "which thread" first.
  confirmations: s => (timelineId) => s.confirmed[String(timelineId || '')] || [],
  dismissed: s => (timelineId) => s.dismissed[String(timelineId || '')] || [],
}

export const actions = {
  // Confirm: remember the file under this thread. Idempotent by ref, so pressing Confirm twice on a
  // re-rendered row does not report the same file twice.
  confirmFound({ commit }, { timelineId, ref, name, at } = {}) {
    if (!timelineId || !ref) return
    commit('CONFIRM_FOUND', { timelineId: String(timelineId), ref: String(ref), name: String(name || 'Document'), at: at || new Date().toISOString() })
  },
  // Delete: the row is not the file. Remembered so it stays gone.
  dismissFound({ commit }, { timelineId, ref } = {}) {
    if (!timelineId || !ref) return
    commit('DISMISS_FOUND', { timelineId: String(timelineId), ref: String(ref) })
  },
  clearThread({ commit }, timelineId) {
    if (!timelineId) return
    commit('CLEAR_THREAD', String(timelineId))
  },
}

export const mutations = {
  CONFIRM_FOUND(s, { timelineId, ref, name, at }) {
    const list = s.confirmed[timelineId] || []
    if (list.some(c => c.ref === ref)) return
    s.confirmed[timelineId] = [...list, { id: ref, ref, at, files: [name] }]
  },
  DISMISS_FOUND(s, { timelineId, ref }) {
    const list = s.dismissed[timelineId] || []
    if (list.includes(ref)) return
    s.dismissed[timelineId] = [...list, ref]
  },
  CLEAR_THREAD(s, timelineId) {
    const confirmed = { ...s.confirmed }
    const dismissed = { ...s.dismissed }
    delete confirmed[timelineId]
    delete dismissed[timelineId]
    s.confirmed = confirmed
    s.dismissed = dismissed
  },
}
